import React from "react";
import LegalPageRenderer from "../components/LegalPageRenderer";

const AcceptableUsePolicy = () => (
  <LegalPageRenderer slug="acceptable-use" testId="acceptable-use-policy-page" />
);

export default AcceptableUsePolicy;
